import { render, staticRenderFns } from "./DraggableSignature.vue?vue&type=template&id=535266c8&"
import script from "./DraggableSignature.vue?vue&type=script&lang=js&"
export * from "./DraggableSignature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('535266c8')) {
      api.createRecord('535266c8', component.options)
    } else {
      api.reload('535266c8', component.options)
    }
    module.hot.accept("./DraggableSignature.vue?vue&type=template&id=535266c8&", function () {
      api.rerender('535266c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/pdf/components/DraggableSignature.vue"
export default component.exports